module.exports = __webpack_public_path__ + "static/wheel-bg.911cb858.png";